module.exports = __webpack_public_path__ + "img/3x.43d22ed.jpg";